export const cookiesUsage = {
    title: 'Использование файлов cookie',
    isBordered: false,
    blocks: [
        {
            type: 'text',
            value: 'Файлы cookie предназначены для сбора сведений о том, какие ссылки на сайте пользуются наибольшей популярностью у посетителей и используются для повышения эффективности работы корпоративного ресурса.',
        },
        {
            type: 'text',
            value: 'Сбор этих данных осуществляется в обобщенном виде и никогда не соотносится с личными сведениями пользователей.',
        },
        {
            type: 'text',
            value: 'Пользователь может отключить в своем браузере прием файлов cookie с нашего сайта, при этом он продолжит получать текстовую и графическую информацию на страницах сайта, однако работа некоторых сервисов будет недоступна.',
        },
    ],
};
